import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { INITIAL_BASIC_INFO } from './consts';
import {
  reset,
  setBasicInfo,
  setGroups,
  setUsers,
  setLoading
} from './actions';

const basicInfoReducer = handleActions(
  {
    [setBasicInfo.toString()]: (_, { payload: basicInfo }) => basicInfo,
    [reset.toString()]: () => INITIAL_BASIC_INFO
  },
  INITIAL_BASIC_INFO
);

const usersReducer = handleActions(
  {
    [setUsers.toString()]: (_, { payload: users }) => users,
    [reset.toString()]: () => []
  },
  []
);

const groupsReducer = handleActions(
  {
    [setGroups.toString()]: (_, { payload: groups }) => groups,
    [reset.toString()]: () => []
  },
  []
);

const loadingReducer = handleActions(
  {
    [setLoading.toString()]: (_, { payload: loading }) => loading,
    [reset.toString()]: () => false
  },
  false
);

export default combineReducers({
  basicInfo: basicInfoReducer,
  users: usersReducer,
  groups: groupsReducer,
  loading: loadingReducer
});
